import { render, staticRenderFns } from "./AddWidget.vue?vue&type=template&id=76f96f8c&scoped=true"
import script from "./AddWidget.vue?vue&type=script&lang=js"
export * from "./AddWidget.vue?vue&type=script&lang=js"
import style0 from "./AddWidget.vue?vue&type=style&index=0&id=76f96f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f96f8c",
  null
  
)

export default component.exports